// extracted by mini-css-extract-plugin
export default {"dateInputField":"EditSuperBatchProjectForm_dateInputField__I2FwM"};